<template>
  <el-container style="height: 100vh;">
    <el-header>
      <el-row>
        <el-col :span="2">
          <router-link tag="a" to="/panel" class="headerlogo">
          </router-link>
        </el-col>
        <el-col :span="18">
          <el-menu mode="horizontal"
                   :collapse-transition="false"
                   :router="true"
                   active-text-color="#0168fa">

            <el-menu-item index="/panel">
              <span slot="title">Panel</span>
            </el-menu-item>
            <el-submenu index="/muhasebe">
              <template slot="title">
                <span slot="title">Muhasebe</span>
              </template>
              <el-menu-item index="/muhasebe/cari">Cari</el-menu-item>
              <el-menu-item index="/muhasebe/hizmet">Hizmet</el-menu-item>
              <el-menu-item index="/muhasebe/grup">Grup</el-menu-item>
            </el-submenu>
            <el-submenu index="/raporlama">
              <template slot="title">
                <span slot="title">Raporlama</span>
              </template>
              <el-menu-item index="/raporlama/zraporu">Z Raporu</el-menu-item>
              <el-menu-item index="/raporlama/kasa">Kasa Raporu</el-menu-item>
              <el-menu-item index="/raporlama/alacak">Alacak Raporu</el-menu-item>
              <el-menu-item index="/raporlama/borc">Borç Raporu</el-menu-item>
              <el-menu-item index="/raporlama/satis">Satış Raporu</el-menu-item>
              <el-menu-item index="/raporlama/alis">Alış Raporu</el-menu-item>
              <el-menu-item index="/raporlama/stok">Stok Raporu</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
        <el-col :span="4">
          <div class="aksiyon">
            <a href="#" class="projesecim" @click="AramaModal=true">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-radio">
                <circle cx="12" cy="12" r="2"></circle>
                <path
                    d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>
              </svg>
              <span>Hızlı İşlem</span>
            </a>
            <a href="#" class="projesecim" @click="ProjeModal=true">
              <svg viewBox="0 0 24 24" width="68" height="68" stroke="currentColor" stroke-width="2" fill="none"
                   stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
              <span>{{ ProjeAdi }}</span>
            </a>
            <a href="#" class="projesecim" @click="CikisYap">
              <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"
                   stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span>{{ $store.state.ju.Adi }}</span>
            </a>
          </div>


        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <router-view @Menu="MenuOlustur($event)"></router-view>
    </el-main>
    <el-dialog
        title="Proje Seçiniz"
        :visible.sync="ProjeModal"
        width="30%"
        center
        :close-on-click-modal="!!Proje_id"
        :close-on-press-escape="!!Proje_id"
        :show-close="!!Proje_id">
      <div class="text-center">
        <el-select v-model="Proje_id" @change="ProjeSecim" filterable placeholder="Proje Seçiniz">
          <el-option
              v-for="item in Projeler"
              :key="item.id"
              :label="item.Adi"
              :value="item.id">
          </el-option>
        </el-select>
      </div>
    </el-dialog>
    <el-drawer
        title="Arama"
        direction="ttb"
        :show-close="false"
        :visible.sync="AramaModalx">
      <div class="AramaDrawer">
        <div class="SayfaBtn el-button-group">
          <el-button size="small" type="default" @click="HizliIslem('OdemeModal')" :disabled="lo">Ödeme İşle <sup>1</sup>
          </el-button>
          <el-button size="small" type="default" @click="HizliIslem('HareketModal')" :disabled="lo">Hareket İşle
            <sup>2</sup>
          </el-button>
          <el-button size="small" type="default" @click="HizliIslem('CariModalDurum')" :disabled="lo">Cari Ekle
            <sup>3</sup>
          </el-button>
        </div>
      </div>
    </el-drawer>
    <div class="Spotlight" v-if="AramaModal">
      <div class="SpotlightKutu">

        <div class="el-button-group">
          <el-button size="small" type="default" @click="HizliIslem('OdemeModal')" :disabled="lo">Ödeme İşle <sup>1</sup>
          </el-button>
          <el-button size="small" type="default" @click="HizliIslem('HareketModal')" :disabled="lo">Hareket İşle
            <sup>2</sup>
          </el-button>
          <el-button size="small" type="default" @click="HizliIslem('CariModalDurum')" :disabled="lo">Cari Ekle
            <sup>3</sup>
          </el-button>
        </div>
      </div>
    </div>
    <HareketIsle v-if="HareketModal" :Durum="HareketModal" @Durum="HareketModal=false"></HareketIsle>
    <CariModal v-if="CariModalDurum" :Durum="CariModalDurum" @Durum="CariModalDurum=false"></CariModal>
    <OdemeIsle v-if="OdemeModal" :Durum="OdemeModal" @Durum="OdemeModal=false"></OdemeIsle>
  </el-container>
</template>

<script>
import CariModal from "../pages/Muhasebe/Cari/Comp/CariModal";
import HareketIsle from "../pages/Muhasebe/Comp/HareketIsle";
import OdemeIsle from "../pages/Muhasebe/Comp/OdemeIsle";

export default {
  components: {OdemeIsle, HareketIsle, CariModal},
  data() {
    return {
      lo: false,
      CariModalDurum: false,
      HareketModal: false,
      OdemeModal: false,
      AramaModal: false,
      AramaModalx: false,
      Proje_id: this.$store.state.Proje_id,
      ProjeAdi: this.$store.state.ProjeAdi,
      ProjeModal: false,
      Projeler: this.$store.state.Proje
    }
  },
  methods: {

    ProjeSecim() {
      this.ProjeAdi = this.Projeler.filter(c => c.id === this.Proje_id)[0].Adi;
      localStorage.setItem('_muduboProje_id', this.Proje_id);
      localStorage.setItem('_muduboProjeAdi', this.ProjeAdi);
      this.$store.dispatch("session", {Proje_id: this.Proje_id, ProjeAdi: this.ProjeAdi})
      this.ProjeModal = false
      this.$notify.info({
        title: this.ProjeAdi + ' Projesi Seçildi',
        customClass: 'info'
      });
    },
    CikisYap() {
      this.$confirm("Oturumu kapatmak istediğinize eminmisiniz?", "Oturum Kapatılacak", {
        confirmButtonText: "Onayla",
        cancelButtonText: "İptal",
        type: 'warning'
      }).then(() => {
        this.$store.dispatch("logout");
      }).catch(() => {
        this.$message.info("Oturum Kapatılmadı");
      });
    },
    HizliIslem(Tur) {
      this.CariModalDurum = false
      this.HareketModal = false
      this.OdemeModal = false
      this.AramaModal = false
      if (Tur === 'OdemeModal') this.OdemeModal = true
      if (Tur === 'HareketModal') this.HareketModal = true
      if (Tur === 'CariModalDurum') this.CariModalDurum = true

    }

  },
  created() {
    if (!this.Proje_id) this.ProjeModal = true

    window.addEventListener('keyup', event => {
      if (event.key === "Control") {
        this.AramaModal = !this.AramaModal
      }
      if (this.AramaModal) {
        if (event.key === "1") this.HizliIslem('OdemeModal')
        if (event.key === "2") this.HizliIslem('HareketModal')
        if (event.key === "3") this.HizliIslem('CariModalDurum')
        if (event.key === "Escape") this.AramaModal = false
      }
    });

  }
};
</script>
<style>
.projesecim {
  position: relative;
}

.projesecim svg {
  z-index: 2;
  fill: #ffffff;
  position: relative;
}

.projesecim span {
  font-family: 'Gilroy', sans-serif;
  font-weight: 600;
  position: relative;
  font-size: 10px;
  z-index: 1;
  border-radius: 2px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  top: -5px;
}
</style>


// WEBPACK FOOTER //
// src/comp/Index.vue